import http from 'axios'

export const formatNumber = (value) => {
	return Number(value).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
export const formatDate = (value) => {
	const date = new Date(value)
	return date.toLocaleDateString('it-IT')
}

// Funzione che restituisce l'ora in formato HH:MM
export const formatHoursMinutes = (hour) => {
	const elements = hour.split(':')
	return `${elements[0]}:${elements[1]}`
}

export const calculatePriceWithOptions = (product) => {
	return product.price + product.options.map(option => {
		return option.values.map(value => Number(value.price_variation)).reduce((a, b) => a + b, 0)
	}).reduce((a, b) => a + b, 0)
}

export const saveAccess = async(pageType, id = null) => {
	const cart = await http.post(`${window.__endpoint}/api/shop/saveAccess`, {
		p: pageType,
		id: id,
	})
}
